

// Media Query Object
/* const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1440px',
    desktop: '2560px'
}; */

// Only for Max width resolution
const size = {
    mobileS: '575.98px',
    mobileM: '767.98px',
    tablet: '992.98px',
    laptop: '1199.98px'
};


// Max width
export const device = {
    mobileS: `(max-width: ${size.mobileS})`,
    mobileM: `(max-width: ${size.mobileM})`,
    tablet: `(max-width: ${size.tablet})`,
    laptop: `(max-width: ${size.laptop})`
};
